import { NavigationItem } from 'src/app/core/components/pages-container/interfaces/navigationList.interface';

export const routes: NavigationItem[] = [
  {
    id: 0,
    name: 'Safety',
    iconClass: 'icon-shield-check-solid',
    routeUrl: '/home',
    children: [],
    permissions: ['OverviewView', 'TrackingView', 'TelematicsView'],
  },
];
